import React from "react";
import { Row, Col, Input, Collapse, Icon, Button, Select } from "antd";

function RecipientsSearch({
  searchParameters,
  onTypeChange,
  onValueChange,
  onSubmit,
}) {
  const { Panel } = Collapse;
  const { type, value } = searchParameters;

  const inputLabel =
    type === "participantAlias"
      ? "Alias de destinatario"
      : "Nombre de destinatario";

  return (
    <div className="Busca">
      <Row>
        <Collapse
          defaultActiveKey={["1"]}
          expandIcon={() => <Icon type="caret-right" />}
        >
          <Panel
            header="Buscador"
            key="1"
            extra={<Icon type="minus-circle" />}
            className="Busca"
          >
            <Row>
              <form onSubmit={onSubmit}>
                <Row
                  className="search-grid-row"
                  gutter={{ xs: 16, sm: 24, md: 32, lg: 40, xl: 48 }}
                  type="flex"
                >
                  <Col xs={24} md={6}>
                    <label>Tipo de búsqueda</label>
                    <br />
                    <Select
                      value={type}
                      onChange={onTypeChange}
                      style={{ width: "100%" }}
                    >
                      <Select.Option value="participantName">
                        Nombre
                      </Select.Option>
                      <Select.Option value="participantAlias">
                        Alias
                      </Select.Option>
                    </Select>
                  </Col>

                  <Col xs={24} md={12}>
                    <label>{inputLabel}</label>
                    <br />
                    <Input
                      type="text"
                      value={value}
                      onChange={onValueChange}
                      style={{ width: "100%" }}
                    />
                  </Col>

                  <Col
                    xs={24}
                    md={6}
                    className="search-actions"
                    style={{ display: "flex", gap: 10, alignItems: "flex-end" }}
                  >
                    <Button htmlType="submit" className="add-btn">
                      Buscar
                    </Button>
                  </Col>
                </Row>
              </form>
            </Row>
          </Panel>
        </Collapse>
      </Row>
    </div>
  );
}

export default RecipientsSearch;
